export default "__VITE_ASSET__D8tw3KRj__"